import { gql } from '@apollo/client';

export const QUERY_SUBSCRIPTIONS = gql`
    query subscriptions($filters: SubscriptionFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = []) {
        subscriptions(filters: $filters, pagination: $pagination, sort: $sort) {
            data {
                id
                attributes {
                    startDate
                    endDate
                    unlimited
                    limit
                    price
                    paid
                    status
                    visitCount
                    publicKey
                    gym {
                        data {
                            id
                            attributes {
                                name
                                address
                            }
                        }
                    }
                }
            }
            meta {
                pagination {
                    page
                    pageSize
                    pageCount
                    total
                }
            }
        }
    }
`;

export const MUTATION_CREATE_SUBSCRIPTION = gql`
    mutation createSubscription($data: SubscriptionInput!) {
        createSubscription(data: $data) {
            data {
                id
            }
        }
    }
`;

export const MUTATION_UPDATE_SUBSCRIPTION = gql`
    mutation updateSubscription($id: ID!, $data: SubscriptionInput!) {
        updateSubscription(id: $id, data: $data) {
            data {
                id
            }
        }
    }
`;
